// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Q0Bx2CO2R9GuOMMFEHDp {\n  background-color: var(--gray-900);\n  color: var(--gray-100);\n  font-weight: var(--font-weight-bold);\n}\n", "",{"version":3,"sources":["webpack://./../lib/src/components/navPills/navPills.module.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,oCAAoC;AACtC","sourcesContent":[".active {\n  background-color: var(--gray-900);\n  color: var(--gray-100);\n  font-weight: var(--font-weight-bold);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"active": "Q0Bx2CO2R9GuOMMFEHDp"
};
export default ___CSS_LOADER_EXPORT___;
